import { createFileRoute } from '@tanstack/react-router';
import type { IUser } from 'common-types';
import { DEFAULT_PROFILE, QueryKey } from 'common-types';
import { insightsQueryKeys } from 'hooks/insights/query-keys';
import { InsightsPageSkeleton } from 'pages/insights/components/skeleton';
import { queryClient } from 'providers/react-query';
import type { JSX } from 'react';
import { lazy, Suspense } from 'react';
import { insightsIndexSearchSchema } from 'router/schemas';
import { getHomeInsightsCategories } from 'services/strapi/strapi';

const Insights = lazy(() => import('pages/insights'));

export const Route = createFileRoute('/_authenticated/_main/insights/')({
  validateSearch: insightsIndexSearchSchema,
  loader: () => {
    const userData = queryClient.getQueryData<IUser>([QueryKey.USER_DATA]);
    const profile = userData?.profileName ?? DEFAULT_PROFILE;

    void queryClient.prefetchQuery({
      queryKey: insightsQueryKeys.homeInsightsCategories({ sort: 'order:asc', profile }),
      queryFn: ({ signal }) => getHomeInsightsCategories({ sort: 'order:asc', signal, profile }),
    });
  },
  component: InsightsWrapper,
});

function InsightsWrapper(): JSX.Element {
  return (
    <Suspense fallback={<InsightsPageSkeleton />}>
      <Insights />
    </Suspense>
  );
}
